module.exports = __webpack_public_path__ + "img/people_outline_white_48dp.a2191d34.svg";